module.exports = __webpack_public_path__ + "static/media/delete.75276bc1.svg";